import React from 'react'

import { FormattedMessage } from 'sb-react-intl'

import messages from './messages'
import s from './DoNotClosePageBanner.scss'


const DoNotClosePageBanner = () => (
  <div className={s.banner}>
    <FormattedMessage {...messages.text} />
  </div>
)


export default DoNotClosePageBanner
